import type { AddUnitDataInterface } from 'store/units/sagaActions';
import type { UnitInfoInterface } from 'store/units/types';
import { getUnitConfig } from 'store/units/unitRegistry';
import {
  CHCrusherGetMaxCSS,
  getBushings,
} from 'unitData/Crushers/CrusherConeCH/CrusherConeCHInfo';
import { UnitTypes } from 'unitData/types';
import type { SmartSelectRecommendedOption } from './smartSelectRecommendations';

export const createSmartSelectUnitInfo = (
  option: SmartSelectRecommendedOption,
  unitInfoData: AddUnitDataInterface,
) => {
  const unitInfo = getUnitConfig(option.unitType).getDefaultData({
    data: unitInfoData as Record<string, unknown>,
    variantId: option.variantId,
    unitType: option.unitType,
  }) as UnitInfoInterface & Record<string, unknown>;

  const selectedUnitInfo: UnitInfoInterface & Record<string, unknown> = {
    ...unitInfo,
    ...(option.modelName ? { modelName: option.modelName } : {}),
    ...(option.concave ? { concave: option.concave } : {}),
    ...(option.mantle ? { mantle: option.mantle } : {}),
    ...(option.unitThrow ? { unitThrow: option.unitThrow } : {}),
  };

  if (
    option.unitType === UnitTypes.CONE_CRUSHER_CH &&
    option.modelName &&
    option.concave &&
    option.mantle &&
    option.unitThrow
  ) {
    const coneData = unitInfoData as Parameters<typeof CHCrusherGetMaxCSS>[4];
    const bushings = getBushings(
      option.modelName,
      option.concave,
      option.unitThrow,
    );

    selectedUnitInfo.bushing = bushings[0] ?? '';
    selectedUnitInfo.maxCSS = CHCrusherGetMaxCSS(
      option.modelName,
      option.mantle,
      option.concave,
      option.unitThrow,
      coneData,
    );
  }

  return selectedUnitInfo;
};
